import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { RootStoreState } from '..';
import * as familyTreeActions from './actions';
import { FamilyTreeService } from '@app/shared/services/family-tree/family-tree.service';

@Injectable()
export class FamilyTreeStoreEffects {
  familyTreeObject = this.store$.select('FamilyTree');

  constructor(
    private familyTreeService: FamilyTreeService,
    private actions$: Actions,
    private store: Store,
    private store$: Store<RootStoreState.State>
  ) {}

  getFamilyTree$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<familyTreeActions.Actions>(familyTreeActions.ActionTypes.GET_FAMILY_TREE_REQUEST),
      switchMap(() => {
        return this.familyTreeService.getFamilyTrees().pipe(
          map((data) => {
            return familyTreeActions.getFamilyTreeSuccess({ payload: data });
          }),
          catchError((error) => {
            return of(familyTreeActions.getFamilyTreeFailure({ error }));
          })
        );
      })
    )
  );

  deleteFamilyTree$: Observable<any> = createEffect(() =>
    this.actions$.pipe(
      ofType<familyTreeActions.Actions>(familyTreeActions.ActionTypes.DELETE_FAMILY_TREE_REQUEST),
      switchMap((action: familyTreeActions.Actions & { familyTreeId: string }) => {
        return this.familyTreeService.deleteFamilyTree(action.familyTreeId).pipe(
          map((data) => {
            this.store.dispatch(familyTreeActions.getFamilyTreeRequest({ loader: false }));
            return familyTreeActions.deleteFamilyTreeSuccess({ familyTreeId: data });
          }),
          catchError((error) => {
            return of(familyTreeActions.deleteFamilyTreeFailure({ error }));
          })
        );
      })
    )
  );
}
